import { ThemeEvents } from "@theme/events";
import { Component } from "@theme/component";

export class AstProductCardSecondary extends Component {

  connectedCallback() {
    super.connectedCallback();
    this.#handleProductFormAddToCartEvent();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  #handleProductFormAddToCartEvent() {
    this.productFormComponent?.addEventListener(ThemeEvents.cartUpdate, this.#handleOnCartUpdated.bind(this));
    this.addToCartButton?.addEventListener('click', this.#handleAddToCartClick.bind(this));
  }

  #handleAddToCartClick() {
    this.addToCartButton?.classList.add('disabled');
  }

  #handleOnCartUpdated() {
    this.addToCartButton?.classList.remove('disabled');
  }

  /**
   * @return {HTMLButtonElement|null}
   */
  get addToCartButton() {
    return this.querySelector('product-form-component button.add-to-cart');
  }

  /**
   * @return {Element|null}
   */
  get productFormComponent() {
    return this.querySelector('product-form-component');
  }

  /**
   * @param {string} value
   */
  set productPriceElValue(value) {
    const el = this.querySelector('.info .price');
    if (el && el instanceof HTMLDivElement) {
      el.innerText = value;
    }
  }

  /**
   * @param {string} id
   */
  set variantId(id) {
    const variantId = this.querySelector('product-form-component input[ref="variantId"]');
    if (variantId && variantId instanceof HTMLInputElement) {
      variantId.value = id;
    }
  }

  /**
   * @param {string} url
   */
  set productUrl(url) {
    const anchor = this.querySelector('a.view-product');
    if (anchor && anchor instanceof HTMLAnchorElement) {
      anchor.href = url;
    }
  }
}

if (!customElements.get('ast-product-card-secondary')) {  
  customElements.define('ast-product-card-secondary', AstProductCardSecondary);
}